import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkle } from "@phosphor-icons/react";
import { FAMILY_BUSINESS_CONCLAVE } from "@/lib/events";

// Narrow promotional band intended to sit at the very top of Home, above
// the tricolour ribbon. Kept dense so it doesn't crowd the hero below.
export default function EventBanner() {
  const e = FAMILY_BUSINESS_CONCLAVE;
  return (
    <div
      data-testid="event-banner"
      className="bg-ocean text-parchment relative grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-3.5 md:py-3 flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
        <div className="flex items-center gap-2 md:gap-3 shrink-0">
          <Sparkle size={14} weight="fill" className="text-brass" />
          <span className="overline text-brass">{e.dateOverline}</span>
        </div>

        <div className="md:flex-1 text-sm md:text-base leading-snug">
          <span className="font-serif text-lg md:text-xl">{e.title}</span>
          <span className="text-parchment/55 hidden md:inline"> · </span>
          <em className="italic text-parchment/80 hidden md:inline">{e.tagline}</em>
        </div>

        <Link
          to={`/events/${e.slug}`}
          data-testid="event-banner-cta"
          className="overline inline-flex items-center gap-2 self-start md:self-auto px-4 py-2 border border-brass/60 text-brass hover:bg-brass hover:text-ocean transition-colors shrink-0"
        >
          Read more &amp; register <ArrowUpRight size={14} weight="bold" />
        </Link>
      </div>
    </div>
  );
}
